module.exports = __webpack_public_path__ + "img/double-points.326e1906.png";